import { CLICK, INPUT, componentWithVariants, demoFile, story, variant } from 'system/demo';
import { ChannelEditorScreen } from 'open-modules/zdf/component/channels/channeleditor';
import { makeAssetUrl } from 'util/util';

const demoChannel0 = {
    channel0: {
        from: 'a',
        isDefault: true,
        key: 'channel0',
        name: 'Default Channel',
        photoUrl: makeAssetUrl('/faces/robo.jpeg'),
    },
};

const demoChannel1 = {
    channel1: {
        from: 'a',
        isDefault: false,
        key: 'channel1',
        name: 'Channel 1',
        photoUrl: makeAssetUrl('/faces/robo.jpeg'),
    },
};

const channelFullDemoData = {
    channelMembers: {
        [demoChannel0.channel0.key]: { memberEmails: ['a@b.com', 'c@d.com'] },
        [demoChannel1.channel1.key]: { memberEmails: [] },
    },
    modulePublic: {
        channel: {
            all: { ...demoChannel0, ...demoChannel1 },
            instanceToChannel: {},
        },
    },
    serverCall: {
        admin: {
            getAdminUsers: async () => [
                { key: 'admin0', roles: ['Moderator'], email: 'a@b.com' },
                { key: 'admin1', roles: ['Moderator'], email: 'c@d.com' },
                { key: 'admin2', roles: ['Moderator'], email: 'test@test.com' },
            ],
        },
        channel: {
            getChannelMembers: async ({ channelKey }) => Promise.resolve(channelFullDemoData.channelMembers[channelKey]),
            addMemberByEmail: async ({ email, channelKey }) => {
                channelFullDemoData.channelMembers[channelKey].memberEmails.push(email);
                return Promise.resolve();
            },
            removeMemberFromChannel: async ({ email, channelKey }) => {
                const list = channelFullDemoData.channelMembers[channelKey].memberEmails.filter((u) => u !== email);
                channelFullDemoData.channelMembers[channelKey].memberEmails = list;
                return Promise.resolve();
            },
            createChannel: async () => Promise.resolve(),
            updateChannel: async () => Promise.resolve(),
        },
    },
};

demoFile('open-modules/zdf/component/channeleditor');

componentWithVariants('ChannelEditorScreen', ChannelEditorScreen, {}, [
    variant('Create channel', {
        instanceKey: 'one',
        state: {
            serverCall: channelFullDemoData.serverCall,
            modulePublic: channelFullDemoData.modulePublic,
            sessionData: { channelMembers: channelFullDemoData.channelMembers },
            roles: ['Owner'],
        }
    }, [
        story('Create default channel', [
            INPUT('image-url', 'https://www.zdf.de/favicon.ico'),
            INPUT('channel-name', 'ZDF'),
            CLICK('default-channel-toggle'),
            CLICK('Create Channel'),
        ]),
        story('Create channel', [
            INPUT('image-url', 'https://www.zdf.de/favicon.ico'),
            INPUT('channel-name', 'ZDF'),
            CLICK('Create Channel'),
        ])
    ]),
    variant('Edit channel', {
        structureKey: 'channel',
        instanceKey: channelFullDemoData.modulePublic.channel.all.channel0.key,
        state: {
            serverCall: channelFullDemoData.serverCall,
            modulePublic: channelFullDemoData.modulePublic,
            sessionData: { channelMembers: channelFullDemoData.channelMembers },
            roles: ['Owner'],
        }
    }, [
        story('Disable default channel', [
            CLICK('default-channel-toggle'),
            CLICK('Save'),
        ]),
        story('Edit channel', [
            INPUT('image-url', 'https://www.cbc.ca/favicon.ico'),
            INPUT('channel-name', 'CBC'),
            CLICK('Save'),
        ])
    ])
]);
